module.exports = __webpack_public_path__ + "img/pencil-blue.0038a9be.svg";